import { ButtonHTMLAttributes, FC } from 'react';

import { Button } from '@shared/components/Button';
import { useNavigate } from 'react-router-dom';

type ButtonColorTheme = 'primary' | 'secondary' | 'default';

export interface ConfirmButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  colorTheme?: ButtonColorTheme;
  to?: string;
}

const BugoBasicButton: FC<ConfirmButtonProps> = function ({
  text,
  to,
  children,
  colorTheme = 'primary',
  className = '',
  onClick,
  ...props
}: ConfirmButtonProps) {
  const navigate = useNavigate();

  const buttonColorStyle = (colorTheme: ButtonColorTheme) => {
    switch (colorTheme) {
      case 'primary':
        //* 브랜드색은 항상 theme-* 로 — 프리드(파랑)·대명 등 태넌트마다 다르다. 하드코딩 금지
        return 'theme-bg-main theme-boder-main';

      case 'secondary':
        return 'bg-gray-800 border-gray-800';
      case 'default':
        return 'bg-white border border-1 border-solid theme-boder-main theme-text-main';
    }
  };

  return (
    <Button
      className={`button-rectangle min-h-[40px] border-solid text-14 text-white ${buttonColorStyle(
        colorTheme,
      )} ${className}`}
      onClick={to ? () => navigate(to) : onClick}
      {...props}
    >
      {text ?? children}
    </Button>
  );
};

export { BugoBasicButton };
